var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white",
    fillOpacity: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11.9V17.3C29 17.5387 28.9052 17.7676 28.7364 17.9364C28.5676 18.1052 28.3387 18.2 28.1 18.2H21.8C21.5613 18.2 21.3324 18.1052 21.1636 17.9364C20.9948 17.7676 20.9 17.5387 20.9 17.3V11.9C20.9 11.6613 20.9948 11.4324 21.1636 11.2636C21.3324 11.0948 21.5613 11 21.8 11H28.1C28.3387 11 28.5676 11.0948 28.7364 11.2636C28.9052 11.4324 29 11.6613 29 11.9ZM18.2 21.8H11.9C11.6613 21.8 11.4324 21.8948 11.2636 22.0636C11.0948 22.2324 11 22.4613 11 22.7V28.1C11 28.3387 11.0948 28.5676 11.2636 28.7364C11.4324 28.9052 11.6613 29 11.9 29H18.2C18.4387 29 18.6676 28.9052 18.8364 28.7364C19.0052 28.5676 19.1 28.3387 19.1 28.1V22.7C19.1 22.4613 19.0052 22.2324 18.8364 22.0636C18.6676 21.8948 18.4387 21.8 18.2 21.8ZM18.2 11H11.9C11.6613 11 11.4324 11.0948 11.2636 11.2636C11.0948 11.4324 11 11.6613 11 11.9V19.1C11 19.3387 11.0948 19.5676 11.2636 19.7364C11.4324 19.9052 11.6613 20 11.9 20H18.2C18.4387 20 18.6676 19.9052 18.8364 19.7364C19.0052 19.5676 19.1 19.3387 19.1 19.1V11.9C19.1 11.6613 19.0052 11.4324 18.8364 11.2636C18.6676 11.0948 18.4387 11 18.2 11ZM28.1 20H21.8C21.5613 20 21.3324 20.0948 21.1636 20.2636C20.9948 20.4324 20.9 20.6613 20.9 20.9V28.1C20.9 28.3387 20.9948 28.5676 21.1636 28.7364C21.3324 28.9052 21.5613 29 21.8 29H28.1C28.3387 29 28.5676 28.9052 28.7364 28.7364C28.9052 28.5676 29 28.3387 29 28.1V20.9C29 20.6613 28.9052 20.4324 28.7364 20.2636C28.5676 20.0948 28.3387 20 28.1 20Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.fdedbd5e6948111f71506046e27b0ee9.svg";
export { ForwardRef as ReactComponent };